import Vue from "vue";
import common from "./common.js"; // 公共接口
import mainServe from "@/api/main.serve.js";
import recomendServe from "@/api/recomend.serve.js";
import searchServe from "@/api/search.serve.js";
import loginServe from "@/api/login.serve.js";
import hundredServe from "@/api/hundred.serve.js";
import bkjxServe from "@/api/bkjx.serve.js";
import wssjServe from "@/api/wssj.serve.js";
import xsjhServe from "@/api/xsjh.serve.js";
import userServe from "@/api/user.serve.js";
import zgqServe from "@/api/zgq.serve.js";
import listServe from "@/api/list.serve.js";
import myServe from "@/api/my.serve.js";
import addressServe from "@/api/address.serve.js";
import goodsServe from "@/api/goods.serve.js";
import paymentServe from "@/api/payment.serve.js";
import zzsignServe from "@/api/zzsign.serve.js";
import afterSalesOrder from "@/api/afterSalesOrder.js";
import extendServe from "@/api/extend.server.js";
import invoiceServe from "@/api/invoice.serve.js";
import signServe from "@/api/sign.serve.js";
const apis = {
  common,
  mainServe,
  recomendServe,
  searchServe,
  loginServe,
  hundredServe,
  bkjxServe,
  wssjServe,
  xsjhServe,
  userServe,
  zgqServe,
  listServe,
  myServe,
  addressServe,
  goodsServe,
  paymentServe,
  zzsignServe,
  afterSalesOrder,
  extendServe,
  invoiceServe,
  signServe
};

export default {
  install() {
    Vue.prototype.$apis = apis;
  },
};
